import axios from "axios";
import endPoints from "../../../../config/endPoints";

export const findReportsApi = async(reqBody) => {
  return await axios.post(`${endPoints.reports}/report`, reqBody);
};
